// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardMessageListController {
   $log: any
   $scope: any
   alerts: any
   emptyListMessage: any
   error: any
   i18n: any
   isLoading: any
   messages: any
   pluralChar: any
   sierraService: any
   libraryCardErrorHelper: any
   constructor($scope: any, $log: any, sierraService: any,  translationService: any, alertService: any, $rootScope: any, $authEvents: any, libraryCardErrorHelper: any) {
      this.$onInit = this.$onInit.bind(this)
      this.$onChanges = this.$onChanges.bind(this)
      this.loadMessages = this.loadMessages.bind(this)
      this.getAlreadyLoadedMessages = this.getAlreadyLoadedMessages.bind(this)
      this.showMessages = this.showMessages.bind(this)
      this.$scope = $scope
      this.$log = $log
      this.sierraService = sierraService
      this.i18n = translationService
      this.isLoading = false
      this.messages = []
      this.pluralChar = ""
      this.alerts = alertService
      this.libraryCardErrorHelper = libraryCardErrorHelper

      $rootScope.$on($authEvents.LOGOUTSUCCESS, () => this.messages = [])
   }

   $onInit() {
      this.loadMessagesWhenReady()
   }

   $onChanges(changesObj: any) {
      if (changesObj.reloadTrigger.currentValue) {
         return this.loadMessagesWhenReady()
      }
   }

   loadMessagesWhenReady(){      
      if (this.sierraService.isUserInfoNull()) {
         return this.loadMessages()
      } else { 
         return this.getAlreadyLoadedMessages()
      }
   }

   loadMessages() {
      this.isLoading = true
      return this.sierraService
         .patronInfoLoadedPromise.promise
         .then(() => {
            this.getAlreadyLoadedMessages()
            this.showMessages()
            return this.isLoading = false
         }).catch((err: any) => {
            this.$log.error(err)
            this.isLoading = false
            const errorMessage =  this.libraryCardErrorHelper.getLibraryCardErrorMessage(err, this.sierraService, this.i18n)
            this.error = this.i18n.translate(this.i18n.translations.MESSAGES_ERROR, {error: errorMessage})
            return this.alerts.setAlert('libraryCardListLoadError', this.error)
         })
   }

   getAlreadyLoadedMessages() {
      this.messages = this.sierraService.getMessages()
      return this.showMessages()
   }

   showMessages() {
      if (this.messages.length === 0) {
         return this.emptyListMessage = this.i18n.translations.MESSAGES_EMPTY
      } else if (this.messages.length > 1) {
         return this.pluralChar = "s"
      }
   }
}

LibraryCardMessageListController.$inject = ['$scope', '$log', 'sierraService', 'translationService', 'alertService', '$rootScope', '$authEvents', 'libraryCardErrorHelper']

angular.module('summonApp.controllers')
   .controller('libraryCardMessageListController', LibraryCardMessageListController)
